<div class="alarm-ringing-widget">
  <div class="header">
    <div class="title">{{ 'WIDGETS.MARRIOTT_ALARM_RINGING.TITLE' | translate }}</div>
    <div class="subtitle">{{ 'WIDGETS.MARRIOTT_ALARM_RINGING.SUBTITLE' | translate }}</div>
  </div>

  <div class="time-display">
    <div class="time-container">
      <span class="time">{{ currentTime }}</span>
      <span class="am-pm">{{ isPM ? 'PM' : 'AM' }}</span>
    </div>
  </div>

  <div class="actions">
    <button class="action-button stop-button htv-selectable htv-focus-99" (click)="stopAlarm()">
      {{ 'WIDGETS.MARRIOTT_ALARM_RINGING.STOP_ALARM' | translate }}
    </button>
    <button class="action-button snooze-button htv-selectable" (click)="snoozeAlarm()">
      {{ 'WIDGETS.MARRIOTT_ALARM_RINGING.SNOOZE_ALARM' | translate }}
    </button>
  </div>
</div>
